import React from "react";
import AdminSidebar from "./AdminSidebar";

const AdminLayout = ({ children }) => {
  return (
    <div className="tracking-wide flex p-0 m-0">
      <AdminSidebar />
      <section className="p-4 w-full">{children}</section>
    </div>
  );
};

export default React.memo(AdminLayout);
